import { Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';

import { UserProfileService } from './api/user-profile.service';

// Reference: https://medium.com/dailyjs/dynamic-locales-in-angular-dd9a527ebe1f

@Injectable({ providedIn: 'root' })
export class LocaleService {

  private _locale: string;
  private _currentCountry: string;
  private _userLocale: string;

  set locale(value: string) {
    this._locale = value;
  }

  get locale(): string {
    return this._locale || 'en-US';
  }

  constructor(private userProfileService: UserProfileService) {
    this._currentCountry = this.userProfileService.getCountryLocalStorage();
    this._userLocale = this.userProfileService.getLocale();
  }

  /**
   * INFO: Register locale data based on the Current Country Config, since only the en-US locale data comes with Angular.
   */
  registerCulture() {
    switch (this._userLocale) {
      case 'cn':
      case 'zh':
        import('@angular/common/locales/zh-Hans').then(lang => registerLocaleData(lang.default));
        break;
      case 'ja':
        import('@angular/common/locales/ja').then(lang => registerLocaleData(lang.default));
        break;
      case 'en-IN':
        import('@angular/common/locales/en-IN').then(lang => registerLocaleData(lang.default));
        break;
      case 'zh-Hant':
        import('@angular/common/locales/zh-Hant').then(lang => registerLocaleData(lang.default));
        break;
      default:
        break;
    }
  }

  getLocale() {
    switch (this._userLocale) {
      case 'cn':
      case 'zh':
        this.locale = 'zh-Hans';
        return 'zh-Hans';
      case 'ja':
        this.locale = 'ja';
        return 'ja';
      case 'en-IN':
        this.locale = 'en-IN';
        return 'en-IN';
      case 'zh-Hant':
        this.locale = 'zh-Hant';
        return 'zh-Hant';
      default:
        this.locale = 'en-US';
        return 'en-US';
    }
  }

  /**
   * 
   * @param val: InputValue 
   * @param userCountry: UserCountry (AUS, IND, etc)
   * @returns The transformed value to be saved.
   */
  getNumericValue(val: string, userCountry: string): string {
    switch (userCountry) {
      default:
        return val.replace(/[^0-9.]/g, '');
    }
  }
}
